var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"jpc-form-wrapper no-overflow-y",attrs:{"h-100":""}},[_c('LoadingMask',_vm._b({},'LoadingMask',_vm.loadingMaskProps,false),[_c('div',{attrs:{"slot":"content","h-100":""},slot:"content"},[_c('div',{staticClass:"payment-object-wrapper",attrs:{"id":_vm.paymentObjectWrapperId}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }